import { Link } from "react-router-dom";
import { ReactElement } from "react";

export default function DisclaimerBanner(): ReactElement {
  return (
    <section className="disclaimer-banner">
      <h1><span>Disclaimer</span></h1>
      <nav aria-label="breadcrumb">
        <ol className="disclaimer-breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li className="font-semibold" aria-current="page">&gt; Disclaimer</li>
        </ol>
      </nav>
    </section>
  );
}
